import { enumConvert } from '../../helpers/enumConvert';
import { RetirementBase } from '../Base/Retirement';

export const Retirement = enumConvert(RetirementBase);
